import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as Styled from 'jobDescriptionMap_styled';
import customMarker from '../../../../../../../public/assets/img/Apploi-Location-Indicator.svg';

// Only import map libraries in browser environment
// This prevents server-side bundle from including browser-only dependencies
let Map;
let Marker;
let FullscreenControl;
let GeolocateControl;
let NavigationControl;
let maplibregl;

if (typeof window !== 'undefined') {
  // CSS import
  // eslint-disable-next-line global-require, import/no-dynamic-require
  require('maplibre-gl/dist/maplibre-gl.css');

  // Dynamic require to prevent webpack from bundling in server bundle
  // eslint-disable-next-line global-require, import/no-dynamic-require
  const mapComponents = require('react-map-gl'.concat('/dist/maplibre'));
  Map = mapComponents.Map;
  Marker = mapComponents.Marker;
  FullscreenControl = mapComponents.FullscreenControl;
  GeolocateControl = mapComponents.GeolocateControl;
  NavigationControl = mapComponents.NavigationControl;

  // MapLibre library
  // eslint-disable-next-line global-require, import/no-dynamic-require
  maplibregl = require('maplibre-gl');
}

const JobDescriptionMap = (props) => {
  const { t } = useTranslation('jobDescription');
  const [error, setError] = useState(null);

  const apiKey = typeof window !== 'undefined' ? window.maptilerAPIKey : null;

  const hasValidCoordinates =
    props?.jobDescription?.latitude && props?.jobDescription?.longitude;

  const initialViewState = {
    latitude: hasValidCoordinates ? props.jobDescription.latitude : 40.73061,
    longitude: hasValidCoordinates
      ? props.jobDescription.longitude
      : -73.935242,
    zoom: 15,
    bearing: 0,
    pitch: 0,
    padding: { top: 0, bottom: 0, left: 0, right: 0 },
  };

  const url = `https://www.google.com/maps/dir/?api=1&destination=${initialViewState.latitude},${initialViewState.longitude}`;

  const handleMarkerClick = () => {
    window.open(url, '_blank');
  };

  const getCleanAddress = () => {
    if (!props.jobDescription?.address) return '';
    return props.jobDescription.address
      .replace(/None,?\s*/g, '')
      .replace(/,\s*$/, '');
  };

  const handleAddressClick = () => {
    const address = props.jobDescription?.address;
    if (address) {
      window.open(url, '_blank');
    }
  };

  const AddressText = () => (
    <Styled.MapLocationText
      onClick={handleAddressClick}
      style={{ cursor: 'pointer' }}
    >
      {getCleanAddress()}
    </Styled.MapLocationText>
  );

  const MapContainerWithHeader = ({ children }) => (
    <Styled.MapContainer>
      <Styled.SectionHeader>{t('location')}</Styled.SectionHeader>
      <AddressText />
      {children}
    </Styled.MapContainer>
  );

  MapContainerWithHeader.propTypes = {
    children: PropTypes.node,
  };

  // Server-side rendering: return loading state
  if (typeof window === 'undefined' || !Map) {
    return (
      <MapContainerWithHeader>
        <div>Loading map...</div>
      </MapContainerWithHeader>
    );
  }

  if (error) {
    // eslint-disable-next-line no-console
    console.error('JobDescriptionMap: Error rendering map');
    return <MapContainerWithHeader />;
  }

  return (
    <MapContainerWithHeader>
      <Map
        mapLib={maplibregl}
        initialViewState={initialViewState}
        style={{ width: '100%', height: '300px' }}
        mapStyle={`https://api.maptiler.com/maps/bright-v2/style.json?key=${apiKey}`}
        onError={(evt) => {
          // eslint-disable-next-line no-console
          console.error('MapLibre error:', evt);
          setError(true);
        }}
      >
        <GeolocateControl position="top-right" />
        <FullscreenControl position="top-right" />
        <NavigationControl position="top-right" />
        <Marker
          longitude={initialViewState.longitude}
          latitude={initialViewState.latitude}
          anchor="bottom"
          onClick={handleMarkerClick}
        >
          <img
            src={customMarker}
            alt="Location marker"
            style={{ width: '45px', height: '54px' }}
          />
        </Marker>
      </Map>
    </MapContainerWithHeader>
  );
};

const mapStateToProps = (state) => ({
  jobDescription: state.jobDescriptionReducer.jobDescription,
});

JobDescriptionMap.propTypes = {
  jobDescription: PropTypes.object,
};

export default connect(mapStateToProps, {})(JobDescriptionMap);
